var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "viewer",
    staticClass: "t-tower t-xmlviewer",
    attrs: {
      "role": "document",
      "tabindex": "0"
    },
    on: {
      "focus": _vm.moveFocusToVisiblePage
    }
  }, _vm._l(_vm.pages, function (page) {
    return _c('div', {
      directives: [{
        name: "observe-visibility",
        rawName: "v-observe-visibility",
        value: function value(isVisible) {
          return _vm.setOnScreen(page.pageNum, isVisible);
        },
        expression: "isVisible => setOnScreen(page.pageNum, isVisible)"
      }],
      key: page.pageNum,
      ref: "page".concat(page.pageNum),
      refInFor: true,
      style: page.pageNum === _vm.lastPage && {
        minHeight: '100vh'
      },
      attrs: {
        "tabindex": "-1"
      }
    }, [_c('XmlPage', _vm._b({
      attrs: {
        "shouldKeep": _vm.shouldKeep(page.pageNum, _vm.onScreenBounds),
        "shouldLoad": _vm.shouldLoad(page.pageNum, _vm.onScreenBounds),
        "isCurrentPage": page.pageNum === _vm.pageNum
      }
    }, 'XmlPage', page, false)), page.pageNum !== _vm.lastPage ? _c('PageBreak') : _vm._e()], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }